import { useMemo } from 'react';
import {
  useQuantzData,
  QuantzOperation,
  QuantzQueryCacheDuration,
  QuantzEventType,
} from '@hotjar/quantz';
import type { QuantzHjEventNameValue } from '@hotjar/quantz';
import { URLConverter, QuerySubKeyEnum } from '@hotjar/global-filters';
import type { GlobalFilter } from '@hotjar/global-filters';

import {
  mapDeviceToGlobalFilter,
  mapTargetingValueToRadioTextFilterOperation,
} from '../lib/mapHeatmapParamsToGlobalFilters';
import type { AggregatePageInsightsHookParams } from '../constants-types/AggregatePageInsights';

interface UseGetPageRageClicksOrUTurnsParams extends AggregatePageInsightsHookParams {
  eventType: QuantzHjEventNameValue.RAGE_CLICK | QuantzHjEventNameValue.U_TURN;
}

export function useGetPageRageClicksOrUTurns({
  eventType,
  selectedDateRange,
  selectedTargetingValue,
  selectedDeviceType,
  searchPattern,
  siteId,
  enabled,
}: UseGetPageRageClicksOrUTurnsParams): number | undefined {
  const tempSearchOperand = URLConverter.convertUiOperation(
    mapTargetingValueToRadioTextFilterOperation(selectedTargetingValue),
  )?.operation;
  const searchOperand = tempSearchOperand ? tempSearchOperand.toString() : 'SIMPLE_MATCH';

  const sessionFilters: GlobalFilter = useMemo(
    () => ({
      dateRange: selectedDateRange,
      filterList: [mapDeviceToGlobalFilter(selectedDeviceType)],
    }),
    [selectedDateRange, selectedDeviceType],
  );

  const { data } = useQuantzData(
    {
      sessionFilters,
      siteId,
      operation: QuantzOperation.COUNT,
      eventType: QuantzEventType.AUTOTAG_RECORDING,
      eventFilters: {
        AND: [
          { EQUAL: { autotag_name: eventType } },
          { [searchOperand]: { [QuerySubKeyEnum.page_path]: searchPattern } },
        ],
      },
    },
    enabled,
    QuantzQueryCacheDuration.Mid,
  );

  return data?.data.result;
}
